import React, { useEffect, useState } from "react";
// Chakra imports
import {
  Flex,
  Table,
  Tbody,
  Icon,
  Text,
  Th,
  Thead,
  Tr,
  Box,
  Grid,
  FormLabel,
  Select,
  useToast,
} from "@chakra-ui/react";

// Custom components
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";

// Table Components
import TablesOrderRow from "components/Tables/TablesOrderRow";

// Data
import { ordersTableData } from "variables/general";
import GradientBorder from "components/GradientBorder/GradientBorder";
import CustomDateInput from "components/CustomField/CustomDateInput";
import { Loader } from "components/Loader/loader";
import useApiReq from "variables/apireq";
import TablesAdvertiserRow from "components/Tables/TablesAdvertiserRow";

// Icons

function AdvertiserList() {
  const titleColor = "white";
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);
  const toast = useToast({ position: "top" });

  useEffect(() => {
    if (error) {
      toast({
        title: "Error",
        description: error,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  }, [error]);
  const fetchAdvertiser = async () => {
    setError(null);
    setIsLoading(true);
    try {
      const res = await useApiReq({
        method: "GET",
        url: "advertiser/list/",
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      if (res.error) {
        setError(res.error?.message || res.error);
      } else {
        setData(res.response.reverse());
      }
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchAdvertiser();
  }, []);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <Flex direction='column' pt={{ base: "120px", md: "75px" }}>
      {/* Authors Table */}
      <Card overflowX={{ sm: "scroll", xl: "hidden" }} pb='0px'>
        <CardHeader p='6px 0px 22px 0px'>
          <Box w='100%'>
            <Text fontSize='lg' color='#fff' fontWeight='bold'>
              Advertisers
            </Text>
          </Box>
        </CardHeader>
        <CardBody>
          <Table variant='simple' color='#fff'>
            <Thead>
              <Tr my='.8rem' ps='0px' color='gray.400'>
                <Th
                  ps='0px'
                  color='gray.400'
                  fontFamily='"Oxygen",serif'
                  borderBottomColor='#56577A'
                  textAlign='center'
                >
                  Advertiser Name
                </Th>
                <Th
                  ps='0px'
                  color='gray.400'
                  fontFamily='"Oxygen",serif'
                  borderBottomColor='#56577A'
                  textAlign='center'
                >
                  Email
                </Th>
                <Th
                  color='gray.400'
                  fontFamily='"Oxygen",serif'
                  borderBottomColor='#56577A'
                  textAlign='center'
                >
                  Address
                </Th>
                <Th
                  color='gray.400'
                  fontFamily='"Oxygen",serif'
                  borderBottomColor='#56577A'
                  textAlign='center'
                >
                  Phone Number
                </Th>

                <Th borderBottomColor='#56577A' textAlign='center'></Th>
              </Tr>
            </Thead>
            <Tbody>
              {data?.map((row, index, arr) => {
                return (
                  <TablesAdvertiserRow
                    user={row?.user}
                    address={row?.address}
                    phone_number={row?.phone_number}
                    lastItem={index === arr?.length - 1 ? true : false}
                  />
                );
              })}
            </Tbody>
          </Table>
        </CardBody>
      </Card>
    </Flex>
  );
}

export default AdvertiserList;
